import { render, staticRenderFns } from "./ClientInfo.vue?vue&type=template&id=2ab4c64a&"
import script from "./ClientInfo.vue?vue&type=script&lang=js&"
export * from "./ClientInfo.vue?vue&type=script&lang=js&"
import style0 from "./ClientInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports